import { memo } from 'react';

const ExpandViewIcon = memo(() => (
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
    <g clip-path='url(#clip0_75644_15325)'>
      <path
        d='M4.8535 7.1465C5.049 7.342 5.049 7.658 4.8535 7.8535L1.707 11H4C4.2765 11 4.5 11.224 4.5 11.5C4.5 11.776 4.2765 12 4 12H1.5C0.673 12 0 11.327 0 10.5V8C0 7.724 0.2235 7.5 0.5 7.5C0.7765 7.5 1 7.724 1 8V10.293L4.1465 7.1465C4.342 6.951 4.658 6.951 4.8535 7.1465ZM10.5 0H8C7.7235 0 7.5 0.224 7.5 0.5C7.5 0.776 7.7235 1 8 1H10.293L7.1465 4.1465C6.951 4.342 6.951 4.658 7.1465 4.8535C7.244 4.951 7.372 5 7.5 5C7.628 5 7.756 4.951 7.8535 4.8535L11 1.707V4C11 4.276 11.2235 4.5 11.5 4.5C11.7765 4.5 12 4.276 12 4V1.5C12 0.673 11.327 0 10.5 0Z'
        fill='#121826'
      />
    </g>
    <defs>
      <clipPath id='clip0_75644_15325'>
        <rect width='12' height='12' fill='white' />
      </clipPath>
    </defs>
  </svg>
));

ExpandViewIcon.displayName = 'ExpandViewIcon';

export default ExpandViewIcon;
